import axios from "axios";

const api = axios.create({ baseURL: `${process.env.REACT_APP_API_URL}` });

// request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      // Use Bearer token format for JWT
      config.headers.Authorization = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
    }
    // config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    // console.log(config);

    return config;
  },
  (error) => {
    console.log("error", error);

    return Promise.reject(error);
  }
);

// response
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    /*      error handling       */
    // console.log(error);

    const originalRequest = error.config;

    // console.log(originalRequest);

    // expired token
    if (error.response?.status === 401) {
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default api;
